'use strict';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _ = require('lodash');

var hardwareUtils = require('./hardware');

var d3Format = require('d3-format');

var _require = require('./formatters'),
    useSignificantDigits = _require.useSignificantDigits;

var logger = console;

try {
  var loggerLib = require('../lib/logger');

  logger = loggerLib.logger;
} catch (_) {}

var registerIsConfigured = hardwareUtils.registerIsConfigured,
    registerIsConsumption = hardwareUtils.registerIsConsumption;

function getRegisterFromHubConfig(hubConfig, blockIndex, channelIndex) {
  try {
    return _.clone(hubConfig[blockIndex][channelIndex]);
  } catch (err) {
    return null;
  }
}

var wattageValueKeys = ['w', 'var', 'avg', 'min', 'max', 'sum'];
var numericalValueKeys = wattageValueKeys.concat(['kwhr', 'kwh', 'cost', 'cost_30d', 'v', 'f', 'i', 'p', 'var', 'w']);
var snapshotKeys = numericalValueKeys.concat(['id', 'label', 'grid', 'main', 'battery', 'production', 'circuit_type', 'other']);

function isWattageProperty(key) {
  return wattageValueKeys.indexOf(key) > -1;
}

function isNumericalProperty(key) {
  return numericalValueKeys.indexOf(key) > -1;
}

function normalizeChannel(channel) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      channelKeys = _ref.channelKeys,
      register = _ref.register,
      minWattageThreshold = _ref.minWattageThreshold;

  if (typeof channelKeys === 'undefined') {
    channelKeys = Object.keys(channel);
  }

  channelKeys.forEach(function (k) {
    var v = channel[k];

    if (typeof v !== 'number') {
      return;
    } // absolute value consumers


    if (registerIsConsumption(register)) {
      v = Math.abs(v);
    } // convert to watt-seconds


    if (isWattageProperty(k)) {
      v = Math.round(v * 3600); // if minWattageThreshold is passed in, all values below that are dropped to 0

      if (minWattageThreshold && Math.abs(v) < minWattageThreshold) {
        v = 0;
      }
    }

    channel[k] = useSignificantDigits(v);
  }); // ensure power and current have the same sign  

  if (channel.i && channel.w && (channel.w > 0 ? 1 : -1) !== (channel.i > 0 ? 1 : -1)) {
    channel.i *= -1;
  }

  return channel;
}
/**
 * DEPRECATED, use flattenSample
 * 
 * @param {*} sample 
 * @param {*} hubConfig 
 * @param {*} channelKeys 
 * @param {*} registerKeys 
 * @param {*} allowUnconfigured 
 */


function mapSampleToSnapshot(sample, hubConfig, channelKeys, registerKeys, allowUnconfigured) {
  var circuitData = [];

  if (!hubConfig || !hubConfig.length) {
    console.warn("Hub config missing for ".concat(sample.h, " - discarding current sample"));
    return null;
  }

  sample.g.forEach(function (block, blockIndex) {
    block.c.forEach(function (channel, channelIndex) {
      var register = getRegisterFromHubConfig(hubConfig, blockIndex, channelIndex);

      if (register) {
        if (!allowUnconfigured && !registerIsConfigured(register)) {
          return;
        }

        var data = normalizeChannel(channel, {
          channelKeys: channelKeys,
          register: register,
          minThreshold: 10
        }); // add any extra values from the register

        (registerKeys || []).forEach(function (key) {
          if (register.hasOwnProperty(key)) {
            data[key] = register[key];

            if (key === 'grid') {
              data['main'] = !!(register.grid && !register.production && !register.battery);
            }
          } else if (key === 'register') {
            data.register = register;
          }
        }); // push to result

        circuitData.push(data);
      }
    });
  }); // return raw, or return post processed with "other" added

  return circuitData;
}
/*
Takes a sample and flattens out the channels and/or groups
It also calls normalizeChannel on each channel, which converts to watt-hours
Adds phase information if phaseMapping is provided
*/

/**
 * 
 * @param {*} sample 
 * @param {*} registerConfig
 * @param {*} phaseCount
 * @param {*} phaseMapping
 * @param {*} includeGroups
 * @param {*} includeChannels
 * @param {*} resolution 
 */


function flattenSample(_ref2) {
  var sample = _ref2.sample,
      hub_online = _ref2.hub_online,
      registerConfig = _ref2.registerConfig,
      phaseCount = _ref2.phaseCount,
      phaseMapping = _ref2.phaseMapping,
      _ref2$includeGroups = _ref2.includeGroups,
      includeGroups = _ref2$includeGroups === void 0 ? false : _ref2$includeGroups,
      _ref2$includeChannels = _ref2.includeChannels,
      includeChannels = _ref2$includeChannels === void 0 ? true : _ref2$includeChannels,
      _ref2$resolution = _ref2.resolution,
      resolution = _ref2$resolution === void 0 ? 's' : _ref2$resolution,
      _ref2$minWattageThres = _ref2.minWattageThreshold,
      minWattageThreshold = _ref2$minWattageThres === void 0 ? 10 : _ref2$minWattageThres;
  var t = sample.t,
      g = sample.g,
      h = sample.h,
      samples_aggregated = sample.samples_aggregated,
      t_min = sample.t_min,
      t_max = sample.t_max;

  var historicalUtils = require('./historical');

  var _historicalUtils$pars = historicalUtils.parseTimeString(resolution),
      seconds = _historicalUtils$pars.seconds;

  var flatSample = {
    t: t,
    h: h,
    c: [],
    g: [],
    hub_online: hub_online,
    phaseCount: phaseCount,
    phaseMapping: phaseMapping,
    registerConfig: registerConfig,
    resolution: resolution,
    seconds: seconds,
    // aggregate values
    samples_aggregated: samples_aggregated,
    t_min: t_min,
    t_max: t_max
  };

  if (Array.isArray(g) && g.length) {
    if (includeGroups) {
      flatSample.g = g.map(function (_g, gi) {
        var groupValues = {};

        for (var prop in _g) {
          if (!isNaN(_g[prop])) {
            groupValues[prop] = useSignificantDigits(_g[prop]);
          }
        }

        return _objectSpread(_objectSpread({}, groupValues), {}, {
          h: h,
          phase: hardwareUtils.getPhaseIndexForGroup(gi, {
            phaseCount: phaseCount
          })
        });
      });
    }

    if (includeChannels) {
      flatSample.c = registerConfig.reduce(function (acc, register) {
        try {
          var channel = g[register.group].c[register.channel];

          if (channel) {
            channel.register = register;

            if (phaseMapping) {
              var _phaseMapping$find = phaseMapping.find(function (pm) {
                return pm.id === register.id;
              }),
                  _phaseMapping$find$ph = _phaseMapping$find.phases,
                  phases = _phaseMapping$find$ph === void 0 ? [] : _phaseMapping$find$ph;

              channel.phases = phases;
            } // remap kwhr => kwh


            if (channel.hasOwnProperty('kwhr') && !channel.hasOwnProperty('kwh')) {
              channel.kwh = channel.kwhr;
              channel.kwhr = undefined;
            }

            var c = normalizeChannel(channel, {
              register: register,
              minWattageThreshold: minWattageThreshold
            }); // add kwh to all flat samples

            if (typeof c.kwh === 'undefined' && typeof c.w === 'number') {
              c.kwh = c.w / 1000 * seconds / 3600;
            }

            acc.push(c);
          }
        } catch (err) {
          logger.error(err);
        }

        return acc;
      }, []);
    }
  }

  return flatSample;
}

; // TODO, add a `g` payload here, which is a flat array of group values (voltage and frequency)

function mapSampleToTimestampedSnapshot(sample, hubConfig) {
  return {
    t: sample.t,
    c: mapSampleToSnapshot(sample, hubConfig, ['w'], snapshotKeys)
  };
}

function mapAggregateToCircuitData(aggregate, hubConfig) {
  var registerKeys = snapshotKeys;

  if (aggregate.g) {
    return mapSampleToSnapshot(aggregate, hubConfig, numericalValueKeys, registerKeys);
  } // if no aggregate data, just return a flattened hub config so that all circuits will be present


  return hubConfig.reduce(function (acc, v) {
    return acc.concat(v);
  }, []).map(function (register) {
    return _objectSpread(_objectSpread({}, _.pick(register, registerKeys)), _.zipObject(numericalValueKeys, numericalValueKeys.map(function (k) {
      return 0;
    })));
  });
}

module.exports = {
  wattageValueKeys: wattageValueKeys,
  numericalValueKeys: numericalValueKeys,
  snapshotKeys: snapshotKeys,
  flattenSample: flattenSample,
  normalizeChannel: normalizeChannel,
  getRegisterFromHubConfig: getRegisterFromHubConfig,
  isWattageProperty: isWattageProperty,
  isNumericalProperty: isNumericalProperty,
  mapSampleToSnapshot: mapSampleToSnapshot,
  mapSampleToTimestampedSnapshot: mapSampleToTimestampedSnapshot,
  mapAggregateToCircuitData: mapAggregateToCircuitData
};